
import axios from 'axios';


class DemoService{

    async request({phone, messenger, currency, language}){
        const response = await axios.post("https://partner.mbk777.com/api/demo/request", arguments[0]);
        return response.data;
    }

    async confirm({phone, code}){
        const response = await axios.post("https://partner.mbk777.com/api/demo/phone/verify", arguments[0]);
        return response.data;
    }
}

export default new DemoService();